export default {
  archiveTypeStat: {
    component: () =>
      import(
        /* webpackChunkName: "statistic_detail" */ "@/mods/statistic/fondsStatistics/detailView/ArchiveTypeStat"
      ),
  },
};
